import { OnDestroy, OnInit } from '@angular/core';
import { ItemService } from '../item.service';
import { FormGroup } from '@angular/forms';
var ItemPagesComponent = /** @class */ (function () {
    function ItemPagesComponent(itemService) {
        this.itemService = itemService;
    }
    ItemPagesComponent.prototype.ngOnInit = function () {
        this.itemService.addField(this.form, {
            pages: [{ page: '' }]
        });
    };
    Object.defineProperty(ItemPagesComponent.prototype, "pagesForm", {
        get: function () {
            return this.form.get('pages');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemPagesComponent.prototype, "showRemovalIcon", {
        get: function () {
            return this.pagesForm.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    ItemPagesComponent.prototype.ngOnDestroy = function () {
        this.form.removeControl('pages');
    };
    ItemPagesComponent.prototype.addPage = function () {
        this.pagesForm.push(this.itemService.createGroupItem({ page: '' }));
    };
    ItemPagesComponent.prototype.removePage = function (index) {
        this.pagesForm.removeAt(index);
    };
    return ItemPagesComponent;
}());
export { ItemPagesComponent };
